import {UserController_GetRealityCheckDataResponse} from "../../../../api/api.service";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {IElasticEventData} from "../../../../../../common/interfaces/structured-logging-service-interface";
import {IRealityCheckAnalytics} from "../../handlers/reality-check-handler.interface";
import {TimeSpentReminderWithBalancePresenter} from "../time-spent-reminder-with-balance-presenter";

export class DenmarkRealityCheckPresenter extends TimeSpentReminderWithBalancePresenter {

    private createAnalytics(analyticsWriter: IRealityCheckAnalytics) {
        return new DenmarkRealityCheckAnalytics(this.services, analyticsWriter);
    }

    protected _onGetRealityCheckDataSuccess(realityCheckData: UserController_GetRealityCheckDataResponse, analyticsWriter: IRealityCheckAnalytics) {
        this.createAnalytics(analyticsWriter).realityCheckMessageSuccess(realityCheckData.TotalNetLoss);
    }

    protected _onGetRealityCheckDataFailed(error: any, analyticsWriter: IRealityCheckAnalytics) {
        this.createAnalytics(analyticsWriter).realityCheckMessageError(error);
    }
}

class DenmarkRealityCheckAnalytics {
    constructor(private readonly services: IServiceFactoryExtended,
                private readonly analyticsWriter: IRealityCheckAnalytics) {

    }

    private readonly _target = 'Denmark-realityCheck';

    private _getCommonEventProperties() {
        return {
            event: 'RealityCheckMessage',
            currencyType: this.services.currency.currencyIso3,
            loggedInTime: this.services.sessionTimer.currentSessionTimer.toString(),
        }
    }

    realityCheckMessageSuccess(totalNetLoss: number): void {
        this.analyticsWriter.sendUniqueAnalyticsEvent('realityCheckMessageSuccess', async () => {
            this._getLogger({
                ...this._getCommonEventProperties(),
                netLoss: totalNetLoss / 100,
                fullMessage: true,
            }).setTarget(this._target)
              .info();
        });

    }

    realityCheckMessageError(error: any) {
        this.analyticsWriter.sendUniqueAnalyticsEvent('realityCheckMessageError', async () => {
            this._getLogger({
                ...this._getCommonEventProperties(),
                fullMessage: false,
                errorDescription: JSON.stringify(error),
            }).setTarget(this._target)
                .error();
        });
    }

    private _getLogger(eventData: IElasticEventData) {
        return this.services.analytics.getLogger(eventData);
    }
}